import { FechaBodyTemplate } from "features/Documentos/templates"

export const CURRENT_DATE_FORMAT_WITH_24_HOURS = "DD/MM/YYYY HH:mm"

export const getLastMovementDate = (
  fechaUltimaActualizacion: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  return fechaUltimaActualizacion
    ? FechaBodyTemplate(
        { fecha: fechaUltimaActualizacion },
        "!tw-text-xs",
        CURRENT_DATE_FORMAT_WITH_24_HOURS
      )
    : `${t("bancos.bankCard.noActual")}`
}
